import { Icon, icon, Tooltip } from '@nula/core-ui';
import { clsx } from 'clsx';
import styles from './frame-sub-panel.module.css';

export interface FramePreset {
  id: string;
  label: string;
  icon: string;
  size: { width: number; height: number } | null;
}

export const FRAME_PRESETS: FramePreset[] = [
  { id: 'custom',  label: 'Custom',   icon: 'open_with',       size: null },
  { id: 'a4',      label: 'A4',       icon: 'description',     size: { width: 794,  height: 1123 } },
  { id: 'letter',  label: 'Letter',   icon: 'description',     size: { width: 816,  height: 1056 } },
  { id: '16:9',    label: '16:9',     icon: 'aspect_ratio',    size: { width: 1920, height: 1080 } },
  { id: '4:3',     label: '4:3',      icon: 'aspect_ratio',    size: { width: 1600, height: 1200 } },
  { id: '1:1',     label: '1:1',      icon: 'crop_square',     size: { width: 1000, height: 1000 } },
  { id: 'mobile',  label: 'Mobile',   icon: 'smartphone',      size: { width: 375,  height: 812  } },
  { id: 'tablet',  label: 'Tablet',   icon: 'tablet_mac',      size: { width: 768,  height: 1024 } },
  { id: 'desktop', label: 'Desktop',  icon: 'laptop_mac',      size: { width: 1440, height: 1024 } },
];

interface FrameSubPanelProps {
  onSelect: (preset: FramePreset) => void;
  activePresetId?: string | null;
}

export function FrameSubPanel({ onSelect, activePresetId }: FrameSubPanelProps) {
  return (
    <div className={styles.root} role="group" aria-label="Frame presets">
      {FRAME_PRESETS.map((preset) => {
        const isActive = activePresetId === preset.id;
        const subtitle = preset.size
          ? `${preset.size.width} × ${preset.size.height}`
          : 'Drag to size';
        return (
          <Tooltip key={preset.id} title={`${preset.label} · ${subtitle}`} placement="top">
            <button
              type="button"
              className={clsx(styles.presetBtn, isActive && styles.active)}
              aria-label={preset.label}
              aria-pressed={isActive}
              onClick={() => onSelect(preset)}
            >
              <Icon name={preset.icon} size={icon.md} />
              <span className={styles.label}>{preset.label}</span>
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
}
